import React from 'react'

import { ApolloClient, ApolloProvider, NormalizedCacheObject } from '@apollo/client'

import { ThemeProvider } from 'styled-components'
import { ModalProvider } from 'styled-react-modal'

import { theme } from '@components/Theme'
import { ConfigProvider } from '@contexts/ConfigProvider'
import { EventProvider } from '@contexts/GTMProvider'
import { ToastProvider } from '@contexts/ToastProvider'
import { Config } from '@lib/Config'
import { UserEvents } from '@lib/UserEvents'
import { Routes } from '@routes/Routes'
import { ResizeContainer, ScrollToTop } from '@utility/index'
import NativeAppInitialiser from '@utility/NativeAppInitialiser'

interface AppProps {
  config: Config
  client: ApolloClient<NormalizedCacheObject>
  events: UserEvents
}

export function App({ config, client, events }: AppProps): JSX.Element {

  return (
    <ConfigProvider config={config}>
      <ScrollToTop>
        <ApolloProvider client={client}>
          <NativeAppInitialiser>
            <ThemeProvider theme={theme}>
              <EventProvider events={events}>
                <ToastProvider>
                  <ModalProvider>
                    <ResizeContainer>
                      <Routes />
                    </ResizeContainer>
                  </ModalProvider>
                </ToastProvider>
              </EventProvider>
            </ThemeProvider>
          </NativeAppInitialiser>
        </ApolloProvider>
      </ScrollToTop>
    </ConfigProvider>
  )
}
